module.exports = require('./helpers/bundle-url').getBundleURL('25ay3') + "logo.c51670a8.svg";